import { CL010_CL553_EU_COUNTRY_CODES } from 'shared/ncts/common/constants'
import { hasText } from 'shared/lib/common-util'
import { COUNTRY_CODE_PREFIX, removePrefix } from 'shared/ncts/common/classifier-util'
import { RuleResult } from '../../../../types/DeclarationP5'

interface Parameters {
  security: string
  placeOfDeliveryCountry: string
  unLocode: string
  additionalDeclarationType: string
}
const validateTraderPartyRequirement = ({
  security,
  placeOfDeliveryCountry,
  unLocode,
  additionalDeclarationType,
}: Parameters): RuleResult => {
  if (!['1', '3'].includes(security)) return 'NOT_ALLOWED'

  const country = removePrefix(placeOfDeliveryCountry, COUNTRY_CODE_PREFIX) ?? ''
  const unLocodeCountry = hasText(unLocode) && unLocode.length >= 2
    ? unLocode.substring(0, 2) : ''

  if (CL010_CL553_EU_COUNTRY_CODES.includes(country) || CL010_CL553_EU_COUNTRY_CODES.includes(unLocodeCountry)) {
    return additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'
  }

  return 'OPTIONAL'
}

const C0942Validator = {
  validateSellerRequirement: (params: Parameters): RuleResult => validateTraderPartyRequirement(params),
  validateBuyerRequirement: (params: Parameters): RuleResult => validateTraderPartyRequirement(params),
}

export default C0942Validator
